module.exports = __webpack_public_path__ + "img/player_recharge.7b26619c.png";